<template>
<div>
  <Login/>
</div>
</template>

<script>

import Login from '@/components/Login/Login'
export default {
  name: 'Func9',
  components: { Login },
  methods: {}
}
</script>

<style scoped>

</style>
